<template>
  <form-dialog
    :max-width="edit ? '1000px' : '600px'"
    v-model="isActive"
    :sending="sending"
    :title="edit ? $t('unita_mobili.azioni.modifica') :  $t('unita_mobili.azioni.nuovo')"
    @confirm="onConfirm">

    <v-flex :md5="edit" xs12>
      <v-flex xs12>
        <text-field :label="$t('unita_mobili.label.targa')" v-model="form.targa" mask="AA###AA"
                    show-details required :disabled="edit" :v-rules="[$utils.rules.targa]"/>
      </v-flex>

      <v-flex xs12>
        <v-textarea :label="$t('label.descrizione')" v-model="form.descrizione" box auto-grow :rows="10" maxlength="500" counter="500"/>
      </v-flex>

      <v-flex xs12>
        <image-input
          :label="$t('unita_mobili.label.immagine')"
          v-model="img"
          :preview="edit && !!form.targa ? $api.unitaMobili.getImgUrl(form.targa) : null"
          full-width/>
      </v-flex>

    </v-flex>

    <v-flex md7 xs12 v-if="edit">
      <v-flex xs12>
        <v-btn color="accent" round block class="mx-0" flat @click="showCaricoMagazzinoDialog" v-if="!$store.getters.isAbbonamentoExpired">
          <v-icon class="mr-2">add</v-icon>
          {{ $t('unita_mobili.azioni.aggiungi_magazzino') }}
        </v-btn>
      </v-flex>

      <v-flex xs12>
        <products-data-table :headers="[{text: $t('prodotti.label.nome'), value: 'name', sortable: true, width: 80},
                                      {text: $t('prodotti.label.quantita'), value: 'quantita', sortable: true, width: 20, right: true},
                                      {text: '', value: 'removable', width: 15, right: true}]"
                             :prodotti="computedProdotti" :loading="prodottiLoading" width-auto
                             :product-dialog-props="{showEditQuantitaUnitaMobile: true}"
                             @quantita-changed="fetchProdotti"
                             :rows-per-page="7"
                             @click:remove="showRemoveProdottoConfirmDialog"/>
      </v-flex>
    </v-flex>

    <unita-mobile-carico-magazzino-dialog ref="caricoMagazzinoDialog" @success="onCaricoMagazzinoSuccess"/>

  </form-dialog>
</template>

<script>

import Sendable from '@/mixins/sendable'
import FormDialog from '@/components/base/FormDialog'
import ImageInput from '@/components/inputs/ImageInput'
import ProductsDataTable from '@/components/ProductsDataTable'
import UnitaMobileCaricoMagazzinoDialog from '@/components/UnitaMobileCaricoMagazzinoDialog'

export default {
    name: 'UnitaMobileDialog',
    mixins: [Sendable],
    components: { UnitaMobileCaricoMagazzinoDialog, FormDialog, ImageInput, ProductsDataTable },
    data () {
        return {
            defaultData: this.$schemas().unitaMobile,
            prodotti: [],
            prodottiLoading: false,
            img: null
        }
    },
    computed: {
        computedProdotti () {
            return this.prodotti.map(val => ({
                ...val,
                targa: this.form.targa,
                quantitaMax: (val.quantita_magazzino + val.quantita)
            }))
        },
        computedForm () {
            let computedForm = new FormData()
            computedForm.append('targa', this.form.targa)
            computedForm.append('descrizione', this.form.descrizione)
            if (this.img !== null) {
                computedForm.append('img', this.img)
            }
            return computedForm
        }
    },
    methods: {
        action () {
            if (this.edit) {
                return this.$api.unitaMobili.update(this.form.targa, this.computedForm)
            } else {
                return this.$api.unitaMobili.create(this.computedForm)
            }
        },
        showEdit (unitaMobile, prodotti) {
            this.prodotti = prodotti
            Sendable.methods.showEdit.call(this, unitaMobile)
        },
        showCaricoMagazzinoDialog () {
            this.$refs.caricoMagazzinoDialog.show(this.form.targa)
        },
        onCaricoMagazzinoSuccess () {
            this.fetchProdotti()
        },
        showRemoveProdottoConfirmDialog (item, index) {
            this.$confirmDialog.show(item, this.$t('unita_mobili.messaggi.conferma_rimozione_prodotto'), (item) => this.removeProdotto(item, index))
        },
        afterReset () {
            this.img = null
        },
        fetchProdotti () {
            this.prodottiLoading = true
            this.$api.unitaMobili.get(this.form.targa).then(response => {
                //  Aggiorno l'array dei prodotti
                this.prodotti.splice(0, this.prodotti.length)
                this.prodotti.push(...response.data.prodotti)
                this.prodottiLoading = false
            }).catch(e => {
                this.$snackbar.showServerError(e)
            })
        },
        removeProdotto (item, index) {
            this.$api.unitaMobili.scaricaProdotto(this.form.targa, item).then(response => {
                this.$snackbar.show(this.$t('unita_mobili.messaggi.prodotto_rimosso'), 'success')
                this.fetchProdotti()
            }).catch(e => {
                this.$snackbar.showServerError(e)
            })
        },
        onConfirm () {
            this.sending = true
            this.action().then(() => {
                this.onSuccess(this.edit ? this.$t('unita_mobili.messaggi.modificato') : this.$t('unita_mobili.messaggi.creato'))
            }).catch(e => {
                if (e.response && e.response.data && e.response.status === 400) {
                    if (e.response.data.message === 'regenerate') {
                        this.sending = false
                        let vue = this
                        //  E' già stata creata una unità mobile con questo nome, mostro la conferma di ripristino
                        this.$confirmDialog.show(
                            this.form.targa,
                            this.$t('unita_mobili.messaggi.conferma_ripristino_duplicato'),
                            function (targa) {
                                this.$api.unitaMobili.restore(targa).then(() => {
                                    vue.onSuccess(this.$t('unita_mobili.messaggi.ripristinato'))
                                })
                            }, { confirmText: this.$t('azioni.ripristina'), color: 'error' })
                    } else if (e.response.data.message === 'used') {
                        this.onError(this.$t('unita_mobili.errori.targa_duplicata'))
                    } else {
                        this.onError(this.$t('errori.server'))
                    }
                } else {
                    this.onError(this.$t('errori.server'))
                }
            })
        }
    }
}
</script>
